/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    header: 'Admin',
    icon: 'PackageIcon',
    i18n: 'admin',
    items: [
      {
        url: '/admin/announcements',
        name: 'Announcements',
        slug: 'admin.announcements',
        icon: 'MicIcon',
        i18n: 'announcements'
      },
      {
        url    : null,
        name   : 'Management',
        icon   : 'SettingsIcon',
        i18n   : 'management',
        submenu: [
          {
            url : '/admin/management/company',
            name: 'Company',
            i18n: 'company',
            slug: 'admin.management.company'
          },
          {
            url : '/admin/management/api-key',
            name: 'Api Key',
            i18n: 'api_key',
            slug: 'admin.management.apiKey'
          },
          {
            url : '/admin/management/manager',
            name: 'Manager',
            i18n: 'manager',
            slug: 'admin.management.manager'
          }
        ]
      },
      {
        url: '/admin/ring-group',
        name: 'Ring Group',
        icon: 'PhoneIcon',
        i18n: 'ring_group',
        slug: 'admin.ringGroup'
      },
      {
        url    : null,
        name   : 'Messages',
        icon   : 'MessageCircleIcon',
        i18n   : 'message',
        isPlural: true,
        submenu: [
          {
            url : '/admin/messages/load',
            name: 'Load',
            i18n: 'load',
            slug: 'admin.messages.load'
          }
        ]
      },
      {
        url    : null,
        name   : 'My Account',
        icon   : 'UserIcon',
        i18n   : 'my_account',
        submenu: [
          {
            url : '/admin/my-account/personal-information',
            name: 'Personal Information',
            i18n: 'personal_information',
            slug: 'admin.my-account.personal-information'
          },
          {
            url : '/admin/my-account/change-password',
            name: 'Change Password',
            i18n: 'change_password',
            slug: 'admin.my-account.change-password'
          }
        ]
      },
      {
        url: '/admin/tasks',
        name: 'Tasks',
        icon: 'ListIcon',
        i18n: 'tasks',
        slug: 'admin.tasks'
      },
      {
        url    : null,
        name   : 'Servers',
        icon   : 'ServerIcon',
        i18n   : 'server',
        isPlural: true,
        submenu: [
          {
            url : '/admin/servers/servers',
            name: 'Servers',
            i18n: 'server',
            isPlural: true,
            slug: 'admin.servers.servers'
          },
          {
            url : '/admin/servers/databases',
            name: 'Databases',
            i18n: 'databases',
            slug: 'admin.servers.databases'
          },
          {
            url : '/admin/servers/nodes',
            name: 'Nodes',
            i18n: 'node',
            isPlural: true,
            slug: 'admin.servers.nodes'
          }
        ]
      }
    ]
  }
]
